import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import QCRouteMiddleware from "./middleware/auth/qcValidRoute";

// ✅ Lazy import
const ReadyForDispatchList = lazy(() => import("app/pages/Inventory/ReadyForDispatch/List"));

export const readyForDispatchRoutes = [
  {
    middleware: [
      {
        element: QCRouteMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/inventory/readyForDispatch",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ReadyForDispatchList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
];
